import * as qs from 'query-string'

type ImageArgs = {
  width?: number
  height?: number
}

export const getKontentImage = (imageUrl: string, args: ImageArgs = {}): string => {
  let params = {
    auto: 'format',
    lossless: true,
  }
  if (args.width) {
    params['w'] = args.width
  }
  if (args.height) {
    params['h'] = args.height
  }
  if (!imageUrl) {
    return ''
  }
  const parsed = qs.parseUrl(imageUrl)
  const mergedQuery = { ...parsed.query, ...params }
  const url = qs.stringifyUrl({ url: parsed.url, query: mergedQuery })

  return url
}
